import { propertyManagingAgentCard } from '../../shared';
import type { ListingLocaleOverrides } from '../base';
import {
  buyersAttorneyContactCard,
  sellersAttorneyContactCard,
} from '../cards';

export const NYOverrides: ListingLocaleOverrides = {
  locale: 'NY',
  sections: {
    sellerSideContacts: {
      cards: {
        sellersAttorneyContactCard,
      },
    },
    buyerSideContacts: {
      cards: {
        buyersAttorneyContactCard,
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: () => propertyManagingAgentCard,
      },
    },
  },
};
